import { createSlice } from "@reduxjs/toolkit";

interface ModalValueType {
  isOpen: boolean;
  side: "left" | "right";
}

const initialState: ModalValueType = {
  isOpen: false,
  side: "left",
};

export const modalSlice = createSlice({
  name: "modalSlice",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isOpen = true;
      state.side = action.payload;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
